/**
 * Day-of-week codes (returned by the Base Rate APIs) mapped to their translation keys.
 *
 * @type {Object.<string, string>}
 */
const DAY_LABELS = {
    sun: 'SUN',
    mon: 'MON',
    tue: 'TUE',
    wed: 'WED',
    thu: 'THU',
    fri: 'FRI',
    sat: 'SAT'
};

/**
 * Detects the accommodation-type minimum-price validation errors (HTTP 422) and shows a
 * warning modal describing the violation. Two variants are handled:
 *
 * 1. Price below minimum on data entry (`price_below_minimum`):
 * {
 *     "price_below_minimum": true,
 *     "message": "PRICE_BELOW_MINIMUM_LIMIT",
 *     "min_price": 100,
 *     "entered_price": 80,
 *     "date": "2026-01-15"   // Base Rate APIs return `day` (e.g. "mon") instead of `date`
 * }
 *
 * 2. Checkout today blocked because existing prices are below the minimum
 *    (`price_below_minimum_checkout_today`, no date):
 * {
 *     "price_below_minimum_checkout_today": true,
 *     "message": "PRICE_BELOW_MINIMUM_CHECKOUT_TODAY",
 *     "min_price": 100,
 *     "entered_price": 80
 * }
 *
 * @param {Object} response - the rejected $http response
 * @param {Object} deps
 * @param {Object} deps.$uibModal
 * @param {Object} deps.$translate
 * @returns {boolean} true when a price-below-minimum error was detected and handled
 */
export function handlePriceBelowMinimumError(response, { $uibModal, $translate }) {

    const data = response && response.data;

    if (!response || response.status !== 422 || !data) {

        return false;
    }

    let message;

    if (data.price_below_minimum) {

        const when = data.date
            ? data.date
            : (data.day ? $translate.instant(DAY_LABELS[data.day] || data.day) : '');

        message = $translate.instant('PRICE_BELOW_MINIMUM_LIMIT_MESSAGE', {
            entered_price: data.entered_price,
            min_price: data.min_price,
            when: when
        });

    } else if (data.price_below_minimum_checkout_today) {

        message = $translate.instant('PRICE_BELOW_MINIMUM_CHECKOUT_TODAY_MESSAGE', {
            entered_price: data.entered_price,
            min_price: data.min_price
        });

    } else {

        return false;
    }

    $uibModal.open({
        component: 'warningModal',
        resolve: {
            message: () => message
        }
    });

    return true;
}



// WEBPACK FOOTER //
// ./src/helpers/price-limit-error.js